import React from 'react'
import TabLink from './TabLink'

const tabs = [
    {
        id: 1,
        title: 'Name your team',
    },
    {
        id: 2,
        title: 'Add project',
    },
    {
        id: 3,
        title: 'Add members',
    },
    {
        id: 4,
        title: 'Select plan',
    }
]

interface TabNavigationProps {
    readonly activeIndex: number;
}

export default function TabNavigation({ activeIndex }: TabNavigationProps) {
    return (
        <div className="flex flex-row justify-between items-center border-b border-gray-100 pb-2 px-8 mb-6 min-w-[722px]">
            {tabs.map((tab) => (
                <TabLink key={tab.id} tab={tab} completed={(tab.id < activeIndex) && (activeIndex !== tab.id)} active={activeIndex === tab.id} />
            ))}
        </div>
    )
}
